/**
 * Layout module.
 *
 * This module will add any layout and display functionality.
 *
 * Libraries:
 * Isotope - handle masonry layouts.
 * imagesLoaded - fixes grid overlapping.
 *
 */
module.exports = function () {

    var isotope = require('isotope-layout'),
        imagesLoaded = require('imagesloaded'),
        $ = require('jquery');

    var rest = require('./rest');

    // Element with grid items for Isotope.
    var grid_elem = $('.grid');

    /**
     * If bigger than mobile breakpoint, load isotope attributes and init
     * 
     * The elements have a data attribute with the settings for isotope
     * 480px is the equivalent of the Bootstrap class $screen-xs-min
     */
    if ( $('html').hasClass('mobile') || $(window).width() <= 480 ) {
        var $isotopeGrid = $('div[data-isotope]');
        if($isotopeGrid.length){
            $.each($isotopeGrid, function (key, value) {
                var isotopeData = $(value).removeAttr('data-isotope');
            });
        }
    }

    $(window).on('irResizedAds', function () {

        $.each(grid_elem, function (key, value) {
            /**
             * Check if there is a grid for Isotope.
             * Wait for all images to load before instantiating isotope.
             *
             * Also re-calculating the height for the dropdown menus
             */
            if (null !== grid_elem) {
                imagesLoaded(value, function (instance) {
                    var iso = new isotope(value, {
                        itemSelector: '.grid-item',
                        percentPosition: true,
                        masonry: {
                            columnWidth: '.grid-sizer'
                        }
                    });
                    var $newHeight = jQuery('html').height() - jQuery('.header').height();
                    jQuery('.dropdown-menu.sub-menu').css('height', $newHeight + 'px');
                });
            }

            /**
             * Grid for list elements (in product page especially)
             */
            if ($('.mason-grid').length > 0) {
                imagesLoaded(value, function (instance) {
                    var msnry = new isotope('.mason-grid', {
                        // options
                        itemSelector: 'ul',
                        percentPosition: true,
                        masonry: {
                            columnWidth: '.grid-sizer'
                        }
                    });
                });

            }
        });
    });

    /**
     * Show more for cut divs
     */
    $('.show-more').on('click', 'a', function (e) {
        e.preventDefault();
        var $gradientBox = $('.add-gradient-bottom');
        if ('100%' === $gradientBox.css('max-height')) {
            $gradientBox.css('max-height', '400px').removeClass('no-gradient');
            $(this).text($(this).data('show-more-text'));
        } else {
            $gradientBox.css('max-height', '100%').addClass('no-gradient');
            $(this).text($(this).data('show-less-text'));
        }
    });

    /**
     * Scroll animation
     */
    $(".scroll").click(function (event) {
        event.preventDefault();
        //calculate destination place
        var dest = 0;
        if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
            dest = $(document).height() - $(window).height();
        } else {
            dest = $(this.hash).offset().top;
        }
        //go to destination
        $('html,body').animate({scrollTop: dest}, 500, 'swing');
    });

    /**
     * Bootstrap tabs
     */
    $('#ir-tabs > li > a').on('click', function (e) {
        e.preventDefault();
        $(this).tab('show');
    });

    /**
     * Wrap special characters in a span.
     *
     * @type {*|jQuery|HTMLElement}
     */
    $("header h1:contains('®')").html(function (_, html) {
        return html.replace(/(®)/g, '<sup class="suffix"> $1</sup>');
    });

    $("header h1:contains('®')").html(function (_, html) {
        return html.replace(/(™)/g, '<sup class="suffix"> $1</sup>');
    });

    /**
     * Provides back to top functionality after user scrolls past top nav
     */
    $(document).ready(function () {
        var $nav = $('.navbar-header:visible:first');
        var target = $nav.offset().top + $nav.height();
        var $footer = $('.footer-bottom:visible:first');
        var content = 17;
        var zCounter = 100;

        $(window).scroll(function () {
            /**
             * Allows the Next and social buttons to be fixed at the top during scrolling
             */
            $('.article-single .social.mobile-only:visible').each(function () {
                var social_top = $(this).offset().top;
                var post_id = $(this).data('postid');

                // Social hits the top of the window
                if (social_top <= $(window).scrollTop()) {
                    if ($('.fixed-social').length === 0) {
                        $('body').append('<div class="fixed-social"></div>');
                        $('.fixed-social').append('<div class="row mobile-only social"></div>');
                    }

                    // Adds the current social buttons to the top fixed social div
                    if ($(".fixed-social .social .mobile[data-postid='" + post_id + "']").length === 0) {
                        $('.fixed-social .social:first').append($(this).html());
                        $('.fixed-social .social .mobile:last').css('z-index', zCounter++);
                        $('.fixed-social .social .mobile:last').attr('data-postid', post_id);
                    }
                } else {
                    // removes the social buttons when user scrolls back 'down' the page
                    $(".fixed-social .social .mobile[data-postid='" + post_id + "']").remove();
                    // clean up fixed social if empty
                    if ($('.fixed-social .social .mobile').length === 0) {
                        $('.fixed-social').remove();
                    }
                }
                // Similar functionality for the "Next Article" div
                $('.article-single .next-title').each(function () {
                    var next_top = $(this).offset().top;
                    var next_bot = next_top + $(this).height();
                    var doc_top = $(window).scrollTop();
                    var doc_bot = doc_top + $(window).height();

                    if ((next_bot <= doc_bot) && (next_top + 90 >= doc_top)) {
                        if ((next_top - doc_top <= 45) && (next_top - doc_top >= -45)) {
                            $('.fixed-social').css('z-index', -1);
                            if ((next_top - doc_top <= -20)) {
                                // 30%
                                $(this).css('opacity', 0.3);
                            } else if ((next_top - doc_top <= -10)) {
                                // 50%
                                $(this).css('opacity', 0.5);
                            } else {
                                // 100%
                                $(this).css('opacity', 1);
                            }
                        } else {
                            $('.fixed-social').css('z-index', 1);
                        }
                    }
                });
            });

            if ($footer.length !== 0) {
                content = $(window).width() + 11 - ( $footer.offset().left + $footer.width() );
            }
            var bottom = $('body').height() - $(window).height() - $('.footer-bottom').height() - $(window).scrollTop();
            if ($(window).scrollTop() >= target && ( bottom >= 0 )) {
                $('.back-to-top').css('right', '40px');
                $('.back-to-top').fadeIn();
            } else {
                $('.back-to-top').fadeOut();
            }

        });
        $('.back-to-top').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({scrollTop: 0}, 'fast');
        });

        $(window).bind('resize load', function () {
            if ($('.newsletter-module-footer .hs_email').length) {
                var $news_form = $('.newsletter-module-footer .hs-form');
                var $email = $news_form.find('.hs_email');
                var $industry = $news_form.find('.hs_industry');
                var $subscribe = $news_form.find('.hs_submit');
                var $sub_width = $subscribe.width() + 30;

                if ($sub_width <= 200) {
                    $email.css('width', (( $news_form.width() - $sub_width ) / 2 ) + 'px');
                    $industry.css('width', (( $news_form.width() - $sub_width ) / 2 ) + 'px');
                } else {
                    $email.css('width', '100%');
                    $industry.css('width', '100%');
                }
            }
        });

        var $leftRail = $('#left-rail'),
            $railParent = $leftRail.parents('div[id^="article-post-id-"]');

        /*
         * Sticky for social and left rail
         */
        if ($('.left-rail.desktop-only', $railParent).length > 0) {
            $(window).bind('load', function () {
                $('.left-rail.desktop-only', $railParent).affix({
                    offset: {
                        top: $('.left-rail.desktop-only', $railParent).offset().top - 20,
                        bottom: function () {
                            return ( $('body').innerHeight() - $('#bottom-links', $railParent).offset().top + $('#bottom-links', $railParent).outerHeight());
                        }
                    }
                });
            });
        }
        if ($('.right-rail.desktop-only', $railParent).length > 0) {
            $(window).bind('load', function () {
                $rightRail = $('.right-rail.desktop-only', $railParent);
                
                $rightRail.affix({
                    offset: {
                        top: $rightRail.offset().top - 20,
                        bottom: function () {
                            return ( $('body').innerHeight() - $('#bottom-links', $railParent).offset().top + $('#bottom-links', $railParent).outerHeight());
                        }
                    }
                });
            });
        }

    });

    /*
     *  Simple image gallery. Uses default settings
     */

    $('.fancybox').fancybox();
    /*
     *  Media helper. Group items, disable animations, hide arrows, enable media and button helpers.
     */
    $('.fancybox-media[rel="media-gallery"], #article-body a[rel="media-gallery"]').on('click', function (e) {
        e.preventDefault();
    });
    $('.fancybox-media[rel="media-gallery"], #article-body a[rel="media-gallery"]')
        .fancybox({
            padding: 0,
            margin: [140, 20, 60, 20],
            helpers: {
                media: {}
            }
        });

    /*
     *  ScrollReveal
     */
    window.sr = ScrollReveal();
    sr.reveal('.timeline-panel');

    /**
     * This checks for any anchor tag and will anchor to its closest section header
     */
    $('a[href^="#"]').on('click', function(e){
        e.preventDefault();

        // Check if we can find the previous section header
        var $sectionHeader = $(this.hash).prev('.row').find('.section-header');
        if ( $sectionHeader.length ) {
            $('html,body').animate({scrollTop:$sectionHeader.offset().top - 50}, 500);
        } else {
            $('html,body').animate({scrollTop:$(this.hash).offset().top - 150}, 500);
        }
    });

};
